<template>
  <div>
    <input
      id="file"
      ref="file"
      type="file"
      style="display: none"
      @change="fileChanged"
    />
    <v-btn small color="primary" @click="$refs.file.click()">
      {{ $t('action.buttons.add') }}
    </v-btn>
    <v-dialog v-model="dialog" scrollable max-width="800">
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 px-2>
              <v-card flat>
                <v-layout align-center justify-center ma-0>
                  <v-img
                    v-if="image"
                    :src="image"
                    class="grey lighten-2"
                    max-width="800"
                  >
                    <template #placeholder>
                      <v-layout align-center justify-center ma-0>
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        />
                      </v-layout>
                    </template>
                  </v-img>
                  <video
                    v-else-if="video"
                    :src="video"
                    width="480"
                    height="360"
                    controls
                  />
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <!-- <upload-button
            v-if="!file"
            small
            color="primary"
            :fileChangedCallback="fileChanged"
            :title="$t('action.actions.upload', {field:''})"
            ref="upload"
          />-->
          <template v-if="file">
            <meta-button type="cancel" @click="cancel" />
            <v-btn small :loading="loading" color="primary" @click="submit">
              {{ $t('action.buttons.save') }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* import UploadButton from 'vuetify-upload-button' */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DialogUpload',
  /*   components: {
    UploadButton,
  }, */

  data() {
    return {
      file: '',
      video: '',
      image: '',
      dialog: false,
    }
  },
  computed: {
    ...mapState({
      userId: (state) => state.users.idSelected,
      loading: (state) => state.files.loading,
    }),
  },
  methods: {
    ...mapActions({
      uploadFile: 'files/uploadGaleryFile',
    }),
    submit() {
      let payload = {
        userId: this.userId,
        file: this.file,
      }
      this.uploadFile(payload).then(() => this.cancel())
    },
    fileChanged(event) {
      if (!event.target.files.length) return
      let file = event.target.files[0]
      this.image = ''
      this.video = ''
      if (file.size < 1) {
        return
      }
      this.dialog = true
      this.file = file
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        if (file.type.includes('image')) vm.image = e.target.result
        else if (file.type.includes('video')) vm.video = e.target.result
      }
      reader.readAsDataURL(file)
    },
    clear() {
      this.file = ''
      this.image = ''
      this.video = ''
    },
    cancel() {
      this.clear()
      this.dialog = false
    },
  },
}
</script>
